import React from "react";
import classNames from "classnames";
import classes from "./Values.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "next-i18next";
import { settings } from "./ValuesCarousel.settings";
import { ReactBootstrapHTMLContainerProps } from "../../../types/htmlElementTypes";
import { Col, Row } from "react-bootstrap";
import TeamSectionHeader from "components/Team/Text/TeamSectionHeader";
import ApprovedSVG from "../../../public/icons/team/approved.svg";
import EffectivenessSVG from "../../../public/icons/team/effectiveness.svg";
import ExperimentSVG from "../../../public/icons/team/experiment.svg";
import FinishSVG from "../../../public/icons/team/finish.svg";
import LoyalitySVG from "../../../public/icons/team/loyality.svg";
import PrincessSVG from "../../../public/icons/team/princess.svg";
import { Value } from "./valuesData";

interface Props extends ReactBootstrapHTMLContainerProps {}

const Carousel = ({ className, ...htmlProps }: Props) => {
  const { t } = useTranslation("team");

  const getIcon = (icon: string) => {
    switch (icon) {
      case "finish":
        return <FinishSVG />;
      case "effectiveness":
        return <EffectivenessSVG />;
      case "loyality":
        return <LoyalitySVG />;
      case "experiment":
        return <ExperimentSVG />;
      case "approved":
        return <ApprovedSVG />;
      case "princess":
        return <PrincessSVG />;
    }
  };

  const modifiedSettings = {
    ...settings,
    customPaging: function (pageNumber: number) {
      return (
        <div key={pageNumber + 1} className={classes.values__dot}>
          {pageNumber + 1}
        </div>
      );
    },
    dotsClass: `slick-dots ${classes.values__dotWrapper}`,
  };

  const values: Value[] = t("carousel.items", {
    returnObjects: true,
  });


  return (
    <div {...htmlProps} className={classNames(className)}>
      <div className={classes.values__customContainer}>
        <Slider {...modifiedSettings}>
          {values.map((value, index) => (
            <div
              key={`carousel-item-${index}`}
              className={classes.values__container}
            >
              <Row className="d-flex justify-content-center">
                <Col xs={12} md={6}>
                  <div className={classes.values__photoBox}>
                    {getIcon(value.image)}
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  className={classNames(
                    classes.values__customRow,
                    "d-flex align-content-center flex-wrap"
                  )}
                >
                  <TeamSectionHeader
                    subTitle={t("values.subTitle")}
                    title={value.title}
                    text={value.text}
                  />
                </Col>
              </Row>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;
